import "./Depoimentos.css";

// Import Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

function Depoimentos() {
  
  const depoimentos = [
    {
      texto:
        "Excelente, equipe atenciosa e sempre pronta para solucionar nossas demandas!",
      nome: "Manoel Izidoro",
      cargo: "Gerente",
      empresa: "Mineração Pedra Líder",
    },
    {
      texto:
        "A Âmbar é a consultoria técnica responsável pela condução do nosso PEA junto às comunidades. A equipe é bastante assertiva e dedicada. Além de estarem atualizadas do ponto de vista legal, possuem um formato muito propositivo e criativo de trabalho, o que faz uma exigência legal, chegar de forma leve e exequível junto aos participantes.",
      nome: "Flaviane Soares",
      cargo: "Consultora de Gestão Social",
      empresa: "Nexa Resources",
    },
    {
      texto:
        "O retorno da Âmbar é certo e ágil em tudo que precisamos, essas meninas tem carisma e competência nos serviços prestados.",
      nome: "Rowena Monteiro",
      cargo: "Gerente",
      empresa: "Pedreira Santo Cristo",
    },
  ];

  return (
    <section className="depoimentos-wrapper py-5" id="depoimentos">
      <div className="container text-center">
        <h2 className="titulo-secao scroll-reveal-zoom">
          Depoimentos
          <span className="barra"></span>
        </h2>

        <p className="mb-5 scroll-reveal-zoom subtitulo-clean">
          A confiança dos nossos clientes é o que impulsiona nosso compromisso
          com a excelência.
        </p>

        {/* CARROSSEL SWIPER */}
       <Swiper
  modules={[Autoplay, Pagination]}
  autoplay={{ delay: 5000, disableOnInteraction: false }}
  loop={true}
  pagination={{ clickable: true }}
  spaceBetween={20}
  slidesPerView={1}
  centeredSlides={false}
  breakpoints={{
    768: { slidesPerView: 2 },
    992: { slidesPerView: 3 },
  }}
  className="depoimentos-carousel"
>

          {depoimentos.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="depoimento-clean-card scroll-reveal-zoom">
                <div className="text-depoimento">
                  <p className="texto-clean">“{item.texto}”</p>
                </div>

                <div className="autor-depoimento">
                  <div className="cliente-clean-info">
                    <strong className="nome-clean">{item.nome}</strong>
                    <br />
                    <p className="cargo-clean">({item.cargo})</p>
                    <span className="empresa-clean">{item.empresa}</span>
                  </div>

                  <div className="estrelas-clean">★★★★★</div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Depoimentos;
